<template>
  <div class="easterEgg">
    <div v-if="me.includes(easterEggData.program)">
      Did you really tried to suppress my whole existence ?
      <div v-if="easterEggData.step >= 1">And you're trying again ??</div>
      <div v-if="easterEggData.step >= 2">I'm done, bye</div>
    </div>
    <div v-if="career.includes(easterEggData.program)">
      So you're trying to erase my career, huh ?
      <div v-if="easterEggData.step >= 1">Am I a joke to you ?</div>
      <div v-if="easterEggData.step >= 2">Well good bye then</div>
    </div>
    <div v-if="personal.includes(easterEggData.program)">
      You want to throw in the bin all the personal projects I did ?
      <div v-if="easterEggData.step >= 1">It won't end well you know</div>
      <div v-if="easterEggData.step >= 2">Well i've warned you, bye</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    easterEggData: Object,
  },
  data: () => {
    return {
      me: ["WhoAmI"],
      career: ["Capsule", "MapFromGeoIP","CleanMob"],
      personal: ["Artfolio", "WiiMenu", "Lyruna", "FramedBot", "Funny404"],
    };
  },
};
</script>